import React from 'react';
import { container } from 'tsyringe';
import { SertifikatTTEPresenter } from '../../../../../data/presenters/SertifikatTTEPresenter';
import { toast } from 'react-toastify';
import { SertifikatPengetahuanPresenter } from '../../../../../data/presenters/SertifikatPengetahuanPresenter';

interface Option {
  label: string;
  value: number;
}

interface IState {
  isLoading: boolean;
  isLoadingLog: boolean;
  formDialog: string;
  showDialog: boolean;
  showPengajuanDialog: boolean;
  nik: number;
  passphrase: string;
  pelatihan_id: number;
  page: number;
  rows: number;
  logTTEData: any[];
  isTteUlang: boolean;
  tteAction: string;
  userId: number;
  accountTTESelected: Option | null;
  showDialogTerimaPengajuan: boolean;
  showDialogTolakPengajuan: boolean;
  showDialogFormTolakPengajuan: boolean;
  isLoadingApproval: boolean;
  formAlasan: string;
  isLoadingTTEPengetahuan: boolean;
  sertifikatPengetahuanData: any[];
  sertifikatPengetahuanTotal: number;
  pagePengetahuan: number;
  perPagePengetahuan: number;
  pengetahuan_id: number;
  tteType: string;
}

interface InitialState {
  state: IState;
  setFormDialog: Function;
  setShowDialog: Function;
  setShowPengajuanDialog: Function;
  setFormNIK: Function;
  setPassphrase: Function;
  setPelatihanId: Function;
  tteSertifikat: Function;
  pengajuanTTESertifikat: Function;
  getLogSertifikat: Function;
  setPage: Function;
  setPageRow: Function;
  setTteUlang: Function;
  setTteAction: Function;
  setUserId: Function;
  setAccountTTESelected: Function;
  setShowDialogTerimaPengajuan: Function;
  setShowDialogTolakPengajuan: Function;
  setShowDialogFormTolakPengajuan: Function;
  actionDialogFormApprovalPengajuan: Function;
  setLoadingApproval: Function;
  setFormAlasan: Function;
  setLoadingTTEPengetahuan: Function;
  getDataTTEPengetahuan: Function;
  setPagePengetahuan: Function;
  setPerPagePengetahuan: Function;
  setPengetahuanId: Function;
  setTteType: Function;
  tteSertifikatPengetahuanPemateri: Function;
  tteSertifikatPengetahuan: Function;
}

const initialState = {
  state: {
    isLoading: false,
    isLoadingLog: false,
    formDialog: '',
    showDialog: false,
    showPengajuanDialog: false,
    nik: 0,
    passphrase: '',
    pelatihan_id: 0,
    page: 1,
    rows: 12,
    logTTEData: [],
    isTteUlang: false,
    tteAction: 'standard',
    userId: 0,
    accountTTESelected: null,
    showDialogTerimaPengajuan: false,
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    isLoadingApproval: false,
    formAlasan: '',
    isLoadingTTEPengetahuan: false,
    sertifikatPengetahuanData: [],
    sertifikatPengetahuanTotal: 0,
    pagePengetahuan: 1,
    perPagePengetahuan: 10,
    pengetahuan_id: 0,
    tteType: '',
  },
  setFormDialog: () => {},
  setShowDialog: () => {},
  setShowPengajuanDialog: () => {},
  setFormNIK: () => {},
  setPassphrase: () => {},
  setPelatihanId: () => {},
  tteSertifikat: () => {},
  pengajuanTTESertifikat: () => {},
  getLogSertifikat: () => {},
  setPage: () => {},
  setPageRow: () => {},
  setTteUlang: () => {},
  setTteAction: () => {},
  setUserId: () => {},
  setAccountTTESelected: () => {},
  setShowDialogTerimaPengajuan: () => {},
  setShowDialogTolakPengajuan: () => {},
  setShowDialogFormTolakPengajuan: () => {},
  actionDialogFormApprovalPengajuan: () => {},
  setLoadingApproval: () => {},
  setFormAlasan: () => {},
  setLoadingTTEPengetahuan: () => {},
  getDataTTEPengetahuan: () => {},
  setPagePengetahuan: () => {},
  setPerPagePengetahuan: () => {},
  setPengetahuanId: () => {},
  setTteType: () => {},
  tteSertifikatPengetahuanPemateri: () => {},
  tteSertifikatPengetahuan: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenSertifikatProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    isLoadingLog: false,
    formDialog: '',
    showDialog: false,
    showPengajuanDialog: false,
    nik: 0,
    passphrase: '',
    pelatihan_id: 0,
    page: 1,
    rows: 12,
    logTTEData: [],
    isTteUlang: false,
    tteAction: 'standard',
    userId: 0,
    accountTTESelected: null,
    showDialogTerimaPengajuan: false,
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    isLoadingApproval: false,
    formAlasan: '',
    isLoadingTTEPengetahuan: false,
    sertifikatPengetahuanData: [],
    sertifikatPengetahuanTotal: 0,
    pagePengetahuan: 1,
    perPagePengetahuan: 10,
    pengetahuan_id: 0,
    tteType: '',
  });

  const setAccountTTESelected = (value: Option | null) => {
    setState((prevstate) => ({
      ...prevstate,
      accountTTESelected: value,
    }));
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setLoadingLog = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoadingLog: value,
    }));
  };

  const clearForm = () => {
    setState((prevstate) => ({
      ...prevstate,
      nik: 0,
      passphrase: '',
      pelatihan_id: 0,
    }));
  };

  const setFormDialog = (value: string) => {
    clearForm();
    setState((prevstate) => ({
      ...prevstate,
      formDialog: value,
    }));
  };

  const setShowDialog = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialog: value,
    }));
  };

  const setShowPengajuanDialog = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showPengajuanDialog: value,
    }));
  };

  const setFormNIK = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      nik: value,
    }));
  };

  const setTteUlang = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isTteUlang: value,
    }));
  };

  const setPassphrase = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      passphrase: value,
    }));
  };

  const setPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihan_id: value,
    }));
  };

  const setPengetahuanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      pengetahuan_id: value,
    }));
  };

  const setTteType = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      tteType: value,
    }));
  }

  const setPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      page: value,
    }));
  };

  const setPageRow = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      row: value,
    }));
  };

  const setTteAction = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      tteAction: value,
    }));
  };

  const setUserId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      userId: value,
    }));
  };

  const tteSertifikat = async () => {
    setLoading(true);

    if (state.accountTTESelected === null) {
      toast.error('Akun TTE Tidak Boleh Kosong!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setLoading(false);
      return;
    }

    try {
      const sertifikatTTEPresenter = container.resolve(SertifikatTTEPresenter);
      const response = await sertifikatTTEPresenter.tteSertifikat(
        state.pelatihan_id,
        state.isTteUlang,
        state.tteAction,
        state.userId,
        state.accountTTESelected.value
      );

      if (response.status === 200) {
        toast.success(response.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      console.log('error saat tte sertifikat :', error);
      toast.error(error?.response?.data?.message ?? 'error saat tte sertifikat', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setLoading(false);
    }
  };

  const pengajuanTTESertifikat = async () => {
    setLoading(true);

    if (state.accountTTESelected === null) {
      toast.error('Akun TTE Tidak Boleh Kosong!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setLoading(false);
      return;
    }

    try {
      const sertifikatTTEPresenter = container.resolve(SertifikatTTEPresenter);
      const response = await sertifikatTTEPresenter.pengajuanTTESertifikat(
        state.pelatihan_id,
        state.isTteUlang,
        state.userId,
        state.accountTTESelected.value,
        'direvisi',
        ''
      );

      if (response.status === 200) {
        toast.success(response.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      console.log('error saat tte sertifikat :', error);
      setLoading(false);
    }
  };

  const getLogSertifikat = async (page, rows) => {
    setLoadingLog(true);

    try {
      const sertifikatTTEPresenter = container.resolve(SertifikatTTEPresenter);
      const tteLog = await sertifikatTTEPresenter.logTTESertifikat(page, rows);

      const data = tteLog;

      setState((prevstate) => ({
        ...prevstate,
        logTTEData: data,
      }));

      setLoadingLog(false);
    } catch (error: any) {
      console.log('error saat get log sertifikat :', error);
      setLoadingLog(false);
    }
  };

  const setShowDialogTerimaPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogTerimaPengajuan: value,
    }));
  };

  const actionDialogFormApprovalPengajuan = async (
    status_pengajuan: string
  ) => {
    setLoadingApproval(true);

    try {
      const sertifikatTTEPresenter = container.resolve(SertifikatTTEPresenter);
      const response = await sertifikatTTEPresenter.pengajuanTTESertifikat(
        state.pelatihan_id,
        state.isTteUlang,
        state.userId,
        0,
        status_pengajuan,
        state.formAlasan
      );

      if (response.status === 200) {
        toast.success('Berhasil Menerima TTE Sertifikat yang diajukan', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setLoadingApproval(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      toast.error('Terjadi Kesalahan Saat Menerima TTE Sertifikat', {
        style: {
          boxShadow: '0px 1px 6px #019166',
        },
      });
      setLoadingApproval(false);
    }
  };

  const getDataTTEPengetahuan = async () => {
    setLoadingTTEPengetahuan(true);
    try {
      const sertifikatPengetahuanTTEPresenter = container.resolve(SertifikatPengetahuanPresenter);
      const response = await sertifikatPengetahuanTTEPresenter.getDataTTEPengetahuan(
        state.pagePengetahuan,
        state.perPagePengetahuan
      );

      setState((prevstate) => ({
        ...prevstate,
        sertifikatPengetahuanData: response.data,
        sertifikatPengetahuanTotal: response.total,
      }));

    } catch (error) {
      toast.error('Ada Kesalahan Saat Mengambil Data!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    } finally {
      setLoadingTTEPengetahuan(false);
    }
  }

  const tteSertifikatPengetahuan = async () => {
    setLoading(true);

    if (state.accountTTESelected === null) {
      toast.error('Akun TTE Tidak Boleh Kosong!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setLoading(false);
      return;
    }

    try {
      const sertifikatPengetahuanTTEPresenter = container.resolve(SertifikatPengetahuanPresenter);
      
      const response = await sertifikatPengetahuanTTEPresenter.tteSertifikatPengetahuan(
        state.pengetahuan_id,
        state.isTteUlang,
        state.accountTTESelected.value
      );

      if (response.status === 200) {
        const successMessage = state.isTteUlang
          ? 'Berhasil! Sertifikat telah diregenerate'
          : 'Berhasil! Sertifikat telah digenerate.';

        toast.success(successMessage, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      console.log('error saat tte sertifikat :', error);
      const title = error.response?.data?.message || 
          'Terjadi kesalahan saat menyimpan data';

      toast.error(title, {
        style: {
          boxShadow: '0px 1px 6px #019166',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const tteSertifikatPengetahuanPemateri = async () => {
    setLoading(true);

    if (state.accountTTESelected === null) {
      toast.error('Akun TTE Tidak Boleh Kosong!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      setLoading(false);
      return;
    }

    try {
      const sertifikatPengetahuanTTEPresenter = container.resolve(SertifikatPengetahuanPresenter);
      
      const response = await sertifikatPengetahuanTTEPresenter.tteSertifikatPengetahuanPemateri(
        state.pengetahuan_id,
        state.isTteUlang,
        state.accountTTESelected.value
      );

      if (response.status === 200) {
        const successMessage = state.isTteUlang
          ? 'Berhasil! Sertifikat telah diregenerate'
          : 'Berhasil! Sertifikat telah digenerate.';

        toast.success(successMessage, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      console.log('error saat tte sertifikat :', error);
      const title = error.response?.data?.message || 
          'Terjadi kesalahan saat menyimpan data';

      toast.error(title, {
        style: {
          boxShadow: '0px 1px 6px #019166',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const setLoadingTTEPengetahuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoadingTTEPengetahuan: value,
    }));
  }

  const setPagePengetahuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      pagePengetahuan: value,
    }));
  };

  const setPerPagePengetahuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      perPagePengetahuan: value,
    }));
  };

  const setLoadingApproval = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoadingApproval: value,
    }));
  };

  const setShowDialogTolakPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogTolakPengajuan: value,
    }));
  };

  const setShowDialogFormTolakPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogFormTolakPengajuan: value,
    }));
  };

  const setFormAlasan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formAlasan: value,
    }));
  };

  return (
    <ManajemenSertifikatProvider
      value={{
        state,
        setFormDialog,
        setShowDialog,
        setShowPengajuanDialog,
        setFormNIK,
        setPassphrase,
        setPelatihanId,
        tteSertifikat,
        pengajuanTTESertifikat,
        getLogSertifikat,
        setPage,
        setPageRow,
        setTteUlang,
        setTteAction,
        setUserId,
        setAccountTTESelected,
        setShowDialogTerimaPengajuan,
        setShowDialogTolakPengajuan,
        setShowDialogFormTolakPengajuan,
        actionDialogFormApprovalPengajuan,
        setLoadingApproval,
        setFormAlasan,
        setLoadingTTEPengetahuan,
        getDataTTEPengetahuan,
        setPagePengetahuan,
        setPerPagePengetahuan,
        setPengetahuanId,
        setTteType,
        tteSertifikatPengetahuanPemateri,
        tteSertifikatPengetahuan,
      }}
    >
      {children}
    </ManajemenSertifikatProvider>
  );
};

export const useManajemenSertifikatContext = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenSertifikatContext,
  Provider,
};
